export const getUsercentricsConsent = (usercentricsServiceName) => {
  return (
    window.UC_UI &&
    window.UC_UI.getServicesBaseInfo().find((service) => service.name === usercentricsServiceName)?.consent
  );
};

export const usercentricsConsentWasGiven = (usercentricsServiceName) => {
  const consent = getUsercentricsConsent(usercentricsServiceName);

  // onInitialPageLoad, user has not yet given consent
  return consent?.history?.[0]?.action === 'onInitialPageLoad' ? undefined : consent?.status;
};
